import { render, staticRenderFns } from "./NewMessagesBadge.vue?vue&type=template&id=34ea082c&scoped=true"
import script from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
export * from "./NewMessagesBadge.vue?vue&type=script&lang=ts"
import style0 from "./NewMessagesBadge.vue?vue&type=style&index=0&id=34ea082c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ea082c",
  null
  
)

export default component.exports